/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { injectIntl, FormattedMessage } from 'react-intl'
import Button from '@vtex/styleguide/lib/Button'
import InputSearch from '@vtex/styleguide/lib/InputSearch'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import Loader from '@/checkout-instore-legacy/components/Commons/Loader'

import OrderCard from './OrderCard'

class OrderCardList extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      orderId: '',
      orders: null,
      loading: true,
      allPagedDownload: false,
      endCursor: null,
      searchTerm: '',
    }
  }

  onOrdersPageLoad = (endCursor, searchTerm = this.state.searchTerm) => {
    this.setState({ loading: true })
    this.props
      .handlePageLoad({
        endCursor,
        query: searchTerm,
      })
      .then((orders) => {
        const currentOrders = this.state.orders || []
        const newOrders = currentOrders.concat(orders.list)
        this.setState({
          orders: newOrders,
          allPagedDownload: newOrders.length >= orders.totalCount,
          loading: false,
          endCursor: orders.pageInfo.endCursor,
        })
      })
  }

  componentDidMount() {
    this.onOrdersPageLoad(this.state.endCursor, this.state.searchTerm)
  }

  render() {
    const {
      orders,
      loading,
      endCursor,
      allPagedDownload,
      searchTerm,
    } = this.state
    const { intl } = this.props

    return (
      <React.Fragment>
        {!orders && <Loader loading={loading} />}
        {orders && (
          <div className="bg-base">
            <div className="mh5 pv6">
              <div className="pb6">
                <form
                  onSubmit={(e) => {
                    e.preventDefault()
                    this.setState({ orders: null })
                    this.onOrdersPageLoad(null, searchTerm)
                  }}
                >
                  <InputSearch
                    placeholder={intl.formatMessage({
                      id: 'orders.table.search',
                    })}
                    value={searchTerm}
                    size="large"
                    onChange={(e) =>
                      this.setState({ searchTerm: e.target.value })
                    }
                    onClear={() => {
                      this.setState({ searchTerm: '', orders: null })
                      this.onOrdersPageLoad(null, '')
                    }}
                  />
                </form>
              </div>
              {orders.map((order) => (
                <OrderCard
                  key={order.orderId}
                  order={order}
                  onClick={() => this.props.handleOrderClick(order.orderId)}
                />
              ))}
              <Button
                variation="secondary"
                size="large"
                onClick={() => {
                  this.onOrdersPageLoad(endCursor)
                }}
                isLoading={loading}
                disabled={allPagedDownload}
                block
              >
                <FormattedMessage id="showMoreProducts" />
              </Button>
            </div>
          </div>
        )}
      </React.Fragment>
    )
  }
}

OrderCardList.propTypes = {
  router: PropTypes.object,
  handlePageLoad: PropTypes.func.isRequired,
  handleOrderClick: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
}

export default injectIntl(withRouter(OrderCardList))
